import {RootState} from "../store";

export const getModules = (state: RootState) => {
    return [...state.modulesReducer.modules.basic, ...state.modulesReducer.modules.additional]
}

export const getBasicModules = (state: RootState) => {
    return state.modulesReducer.modules.basic
}


export const getAdditionalModules = (state: RootState) => {
    return state.modulesReducer.modules.additional
}

